import Vue from 'vue'
import Buefy from 'buefy'
import GoogleCalendarService from '@/services/GoogleCalendarService'
import Vue2TouchEvents from 'vue2-touch-events'
import App from './App.vue'
import router from './router'
import store from './store'


Vue.use(Vue2TouchEvents)
Vue.use(Buefy)
Vue.config.productionTip = false

const googleCalendarService = new GoogleCalendarService(() => {
  store.dispatch('updateSignState')
  if (store.state.isSignedIn) {
    store.dispatch('updateRooms')
  } else {
    store.dispatch('signIn')
  }
})
Vue.$googleCalendarService = googleCalendarService

Object.defineProperty(Vue.prototype, '$googleCalendarService', {
  get () {
    return googleCalendarService
  }
})

Vue.filter('shortRoomName', longRoomName => {
  if (longRoomName) {
    const regex = /.*-(.*)\s\(.*/s
    let m = regex.exec(longRoomName)
    if (m !== null) {
      return m[1]
    }
  }
  return ''
})

Vue.filter('shortTimeFormatOcp', date => {
  if (!date) {
    return ''
  } else if (date.hour()) {
    return date.format('HH[:]mm [Std.]')
  } else {
    return date.format('mm [Minuten]')
  }
})

new Vue({
  router,
  store,
  render: h => h(App),
  mounted: function () {
    const self = this
    // start auto refresh timer for calendar event updates
    setInterval(function () {
      self.$store.dispatch('updateResourceEvents')
    }, parseInt(self.$store.state.settings.refreshInterval) * 1000)
  }
}).$mount('#app')
